import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

import { css } from 'styled-components';
import { BUTTON_BACKGROUND_APPEARANCES } from "../../constants";
import { getButtonContentElementsColor } from "../../shared-styles";
import { focusOutlinesStyles } from "./../../../core";
export var textButtonStateStyles = {
  "default": {
    active: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      background-color: ", ";\n      ", ";\n    "])), function (_ref) {
      var theme = _ref.theme;
      return theme.color.state.primary.pressed.value;
    }, function (_ref2) {
      var theme = _ref2.theme;
      return getButtonContentElementsColor(theme.color.primary[700].value);
    }),
    "default": css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", ";\n    "])), function (_ref3) {
      var theme = _ref3.theme;
      return getButtonContentElementsColor(theme.color.primary[500].value);
    }),
    disabled: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      ", ";\n    "])), function (_ref4) {
      var theme = _ref4.theme;
      return getButtonContentElementsColor(theme.color.text.light.disabled.value);
    }),
    focus: css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      ", ";\n      ", ";\n    "])), function (_ref5) {
      var theme = _ref5.theme;
      return theme.color.state.primary.focus.value;
    }, function (_ref6) {
      var theme = _ref6.theme;
      return getButtonContentElementsColor(theme.color.primary[600].value);
    }, focusOutlinesStyles.primary),
    hover: css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      ", ";\n    "])), function (_ref7) {
      var theme = _ref7.theme;
      return theme.color.state.primary.hover.value;
    }, function (_ref8) {
      var theme = _ref8.theme;
      return getButtonContentElementsColor(theme.color.primary[600].value);
    })
  },
  defaultOnPrimaryBackground: {
    active: css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), function (_ref9) {
      var theme = _ref9.theme;
      return theme.color.state.dark.pressed.value;
    }),
    "default": css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      ", ";\n    "])), function (_ref10) {
      var theme = _ref10.theme;
      return getButtonContentElementsColor(theme.color.additional.light.value);
    }),
    disabled: css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      ", ";\n    "])), function (_ref11) {
      var theme = _ref11.theme;
      return getButtonContentElementsColor(theme.color.text.dark.disabled.value);
    }),
    focus: css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      ", ";\n    "])), function (_ref12) {
      var theme = _ref12.theme;
      return theme.color.state.dark.focus.value;
    }, focusOutlinesStyles.light),
    hover: css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), function (_ref13) {
      var theme = _ref13.theme;
      return theme.color.state.dark.hover.value;
    })
  }
};
export var getStateStyles = function getStateStyles(backgroundAppearance) {
  return backgroundAppearance === BUTTON_BACKGROUND_APPEARANCES.LIGHT ? textButtonStateStyles["default"] : textButtonStateStyles.defaultOnPrimaryBackground;
};